import { html } from 'fxjs/es';

export const product = html`
  <div class="product_menu super_menu">
    <div class="main_icon circle_icon product_icon">
      <div class="icon"></div>
      <div class="text">${T('maker::Product')}</div>
    </div>
    <div class="main_icon circle_icon zoom_in_1">
      <div class="icon"></div>
      <div class="text">${T('maker::100%')}</div>
    </div>
  </div>
`;

export const onlyImageUploadIcon = (flexiMaker) => {
  return html`<ul class="flexi_icon ${flexiMaker?.hasImage ? '' : 'disabled'}">
    <li class="my_lib circle_icon">
      <div class="icon"></div>
      <div class="text">${T('Image')}</div>
      <input
        type="file"
        style="display: none;"
        accept="image/jpeg,image/png,image/pjpeg,image/tiff,application/postscript"
      />
    </li>
    <li class="size circle_icon">
      <div class="icon"></div>
      <div class="text">사이즈</div>
    </li>
  </ul>`;
};
